<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Offline Canteen Fees Payment</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" @change="getStudents()" />
                    </v-col>
                    <v-col cols="12" sm="3" v-if="this.all_learner_list!=''">
                        <p><b>Learner</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="learner"
                            :items="all_learner_list" item-text="learner" item-value="id" label="Student"
                            @change="getLearnerCanteenFeesInstallments()" outlined persistent-hint
                            hint="Please Select Student" />
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="box" v-if="canteen_installments != ''">
                <v-data-table :headers="headers_new" dense class="elevation-1" :items="canteen_installments">
                    <template v-slot:top>
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Canteen Payment Installment Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.ispaid`]="{ item }">
                        <span v-if="item.is_approved">
                            <!-- <span v-if="item.ispaid == false"> -->
                            <span v-if="item.amount_to_pay > 0">
                                <v-tooltip top color="warning">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" :disabled="isExpired(item.to_date)"
                                            v-on="on" @click="pay(item)">Pay Fees</v-btn>
                                    </template>
                                    Pay Fees
                                </v-tooltip>
                            </span>
                            <span v-else> Already Paid </span>
                        </span>
                        <span v-else> Application Not Approved Yet </span>
                    </template>
                    <template v-slot:[`item.print`]="{ item }">
                        <span v-for="(item, i) in item.receipt_no" :key="i">
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs"
                                        v-on="on" @click="print(item, item.ay)"> <v-icon
                                            color="warning">mdi-printer</v-icon>{{ item }}</v-btn>
                                </template>
                                <span> Print Fee Receipt!!! </span>
                            </v-tooltip>
                        </span>
                    </template>
                    <template v-slot:[`item.edit`]="{ item }">
                        <!-- {{item}} -->
                        <span v-for="(item1, i) in item.receipt_data" :key="i">
                            <v-tooltip top color="teal">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" class="ma-2" closable color="teal" text-color="teal"
                                        rounded small outlined @click="editItemFeeReceipt(item1)">
                                        <v-icon small>edit</v-icon>
                                        {{item1.receipt_no}}
                                    </v-btn>
                                </template>
                                <span> Edit Receipt !!!</span>
                            </v-tooltip>
                        </span>
                    </template>

                    <template v-slot:[`item.delete_installment`]="{ item }">
                        <span v-if="item.can_delete_installment">
                            <v-avatar size="35">
                                <v-icon class="mr-4 v-icon-size" color="red"
                                    @click="deleteInstallment(item)">mdi-trash-can</v-icon>
                            </v-avatar>
                        </span>
                        <span v-else>
                            --
                        </span>
                    </template>
                </v-data-table>
            </v-card>
            <v-card ref="payment_details" class="box" v-if="show_payment_card">
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title>Select Payment Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row align="center" style="float: both;">
                    <v-col cols="12" sm="2">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="payment_mode" :items="mode_list"
                            item-text="name" item-value="id" label="Payment Mode" outlined persistent-hint
                            hint="Please Select Payment Mode" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field outlined rounded label="Transaction ID" v-model="trans_id" placeholder="123"
                            dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-text-field label="*Amount" v-model="amount" placeholder="123"
                            :rules="[(v) => !!v || 'Amount is required']" type="number" dense rounded outlined
                            hint="Amount is required"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field rounded label="Remark" placeholder="Remark" v-model="receipt_remark" dense
                            outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on,attrs }">
                                <v-text-field dense v-model="receipt_date" v-bind="attrs" v-on="on" rounded outlined
                                    hint="Date" prepend-icon="event" persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title :max="nowDate"
                                @input="menu1 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>

                <v-row justify="center" dense v-if="show_payment_card && this.payment_mode">
                    <v-btn color="warning" @click="saveCanteenInstallmentFees()">Pay</v-btn>
                </v-row>
            </v-card>
            <v-dialog v-model="dialog_edit_fee" max-width="1000px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <edit-canteen-receipt :key="canteen_cnt" :payment_mode_list="mode_list"
                            @changedialog="chnaged($event)"></edit-canteen-receipt>
                    </v-col>
                    <v-row justify="center" dense>
                        <v-btn class="button mt-3"
                            @click="dialog_edit_fee = false;edit_canteen_receipt = null">Cancel</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import EditCanteenReceipt from "./EditCanteenReceipt";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
      components: {
            "edit-canteen-receipt": EditCanteenReceipt,
            Breadcrumbs
      },
        data: () => ({
            canteen_installments: [],
            loader: false,
            snackbar_msg: "",
            color: "",
            // extraBreadcrumbItems: [
             

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            snackbar: false,
            overlay: false,
            title: "",
            description: "",
            headers_new: [
                { text: "Sr No", value: "srno" },
                { text: "Installment", value: "name" },
                { text: "Amount", value: "amount" },
                { text: "Amount Paid Till Now", value: "paid_till_now" },
                { text: "Amount To Pay", value: "amount_to_pay" },
                { text: "Approval Status", value: "canteenapprovalstatus" },
                { text: "Payment", value: "ispaid" },
                { text: "Print Receipt", value: "print" },
                { text: "Edit Receipt", value: "edit" },
                { text: "Delete Installment Applied", value: "delete_installment" },
            ],
            // headers: [
            //   { text: "Sr. No.", value: "count", sortable: true },
            //   {
            //     text: "Installment",
            //     value: "learnertransportfeesinstallment",
            //     sortable: true,
            //   },
            //   { text: "Receipt No", value: "receipt_no", sortable: true },
            //   { text: "Amount", value: "amount", sortable: true },
            //   { text: "Receipt Date", value: "receipt_date", sortable: true },
            //   { text: "Payment Mode", value: "paymentmode", sortable: true },
            //   { text: "Remark", value: "remark", sortable: true },
            //   { text: "Transaction Id", value: "transaction_id", sortable: true },
            //   { text: "Transaction Date", value: "transaction_date", sortable: true },
            // ],
            payment_mode: "",
            receipt_date: "",
            bank: "",
            trans_id: "",
            amount: 0,
            receipt_remark: "",
            ay_list: [],
            ay: "",
            all_learner_list: [],
            learner: "",
            learner_canteen_fees_installments: [],
            learner_canteen: "",
            show_payment_card: false,
            canteen_fees_receipts: [],
            learner_canteen_fees_installment_id: "",
            mode_list: [],
            bank_list: [],
            date: new Date().toISOString().substr(0, 10),
            nowDate: new Date().toISOString().slice(0, 10),
            menu1: false,
            edit_canteen_receipt:null,
            dialog_edit_fee:false,
            canteen_cnt:0
        }),
        methods: {
            isExpired(toDate) {
                if (!toDate || toDate === "--") return false;

                const [day, mon, year] = toDate.split("/");
                const months = {
                Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
                };

                const endDate = new Date(year, months[mon], day);
                endDate.setHours(0, 0, 0, 0);

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                return endDate < today; // expired if end date is before today
            },
              deleteInstallment(canteen_installment){
                  if (!confirm("Are You Sure You Want To Delete Installment...?")) return;
                const data = {
                    canteen_installment: canteen_installment.learner_canteen_fees_installment_id,
                };
                this.overlay = true;
                axios
                    .post("/Canteen/deleteInstallment", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                          //  this.transport_installments = res.data.transport_installments;
                            this.learner_canteen_installments = res.data.learner_canteen_installments;
                            this.showSnackbar("green", "Deleted Successfully...");
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                       // this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.getLearnerCanteenFeesInstallments()
                    });
            },
           chnaged(dialog) {
            this.dialog_edit_fee = dialog;
            this.edit_canteen_receipt = null
            this.getLearnerCanteenFeesInstallments();
          },
           editItemFeeReceipt(item) {
            this.edit_canteen_receipt = null
            this.dialog_edit_fee = true;
            this.edit_canteen_receipt = item;
            this.canteen_cnt++
            this.$store.commit("setreceipt_data", this.edit_canteen_receipt);
          },
            getStudents() {
                this.all_learner_list = [];
                const data = {
                    learner: this.learner,
                    ay: this.ay,
                };
                this.overlay = true;
                axios
                    .post("/Canteen/getCanteenApplicationsByAy", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.all_learner_list = res.data.all_learner_list;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            print(receipt_no, ay) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                let routeData = this.$router.resolve({ name: "canteen-receipt" });
                window.open(routeData.href, "_blank");
            },
            saveCanteenInstallmentFees() {
                const data = {
                    learner: this.learner,
                    ay: this.ay,
                    learner_canteen: this.learner_canteen_fees_installment_id,
                    amount: this.amount,
                    payment_mode: this.payment_mode,
                    receipt_remark: this.receipt_remark,
                    receipt_date: this.receipt_date,
                    bank: this.bank,
                    trans_id: this.trans_id,
                };
                this.overlay = true;
                axios
                    .post("/Canteen/saveCanteenInstallmentFees", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.canteen_installments = res.data.canteen_installments;
                            this.showSnackbar("green", "Payment Successful...");
                            this.show_payment_card = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            pay(learner_canteen) {
                this.learner_canteen_fees_installment_id = learner_canteen.learner_installment_id;
                this.amount = learner_canteen.to_pay;
                this.show_payment_card = true;
                this.showCard();
            },
            showCard() {
                setTimeout(() => {
                    this.$vuetify.goTo(this.$refs.payment_details); // for scrolling down
                }, 500);
            },
            getLearnerCanteenFeesInstallments() {
                const data = {
                    learner: this.learner,
                    ay: this.ay,
                };
                this.overlay = true;
                axios
                    .post("/Canteen/getLearnerCanteenFeesInstallments", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_canteen_fees_installments = res.data.learner_canteen_fees_installments;
                            this.mode_list = res.data.mode_list;
                            this.bank_list = res.data.bank_list;
                            this.canteen_installments = res.data.canteen_installments;
                            //  this.show_payment_card=true
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            onLoad() {
                axios
                    .post("Canteen/payCanteenFees")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                            (this.all_learner_list = res.data.all_learner_list), (this.overlay = false);
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        watch: {
            date(val) {
                this.receipt_date = this.formatDate(this.date);
            },
        },
        mounted() {
            this.onLoad();
            this.receipt_date = this.formatDate(this.date);
        },
    };
</script>
<style scoped></style>
